import annotator from '@/services/annotator'
import AnnotatorStorage from '@/utils/annotatorStorage'
import { jsonData, isOnline } from '@/utils/utils'
import bookSync from '@/services/booksync'
import {UserDB} from '@/services/db'

const db = new UserDB()

const initAnnotation = async ({rootState, commit}, obj) => {
  const bookId = rootState.book.book._id
  const pageNo = obj.page

  await annotator.init({
    element: obj.element,
    access_token: rootState.user.accessToken,
    book_id: bookId,
    page: pageNo,
    user: rootState.user.user,
    cachedAnnotation: await db.getAnnotations({book: bookId, page: pageNo})
  })
}

const fetchAllAnnotations = async ({rootState, commit}) => {
  if (rootState.user.accessToken !== null) {
    if (!isOnline()) {
      return
    }

    const annotationData = await bookSync.getBookAnnotations(rootState.user.accessToken, rootState.book.book._id)

    if (annotationData.objects) {
      annotationData.objects.forEach(function (data) {
        db.annotations.put(jsonData(data))
      })
    }
  }
}

const getAllAnnotationsFromDB = async ({rootState, commit}) => {
  if (rootState.user.accessToken !== null) {
    commit('SET_ANNOTATIONS', await db.getAnnotations({book:rootState.book.book._id}))
  }
}

export default {
  initAnnotation,
  fetchAllAnnotations,
  getAllAnnotationsFromDB
}
